import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { getServiceLabel } from '../../../../../../common/customControls/getServiceLabel';
import { ServiceCode } from '../../../../../../common/enums/serviceCode';
import { getDisplayName } from '../../../../../../common/utils/getDisplayName';
import { translateKey } from '../../../../../translate';
import { RequestReadButtons } from '../../../../elements/carePathButtons/RequestReadButtons';
import { ProcessContainer } from '../../../episodes/common';
import { ProcessItemFooter } from '../../../episodes/ProcessItemFooter';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';
import { OrthCV1RequestReadInner } from './OrthCV1RequestReadInner';

export function OrthCV1RequestRead(props: ICustomControlRequestReadProps) {
    if (!props.request.customControlData) {
        return null;
    }

    return (
        <ProcessContainer>
            <ProcessItemHeader
                date={props.process.dateSent || (props.request && props.request.dateSent)}
                isFirstItem={props.isFirstItem}
                isFirstProcess={props.itemState.isFirstProcess}
                isItemOpen={props.itemState.isOpen}
                onToggle={(isOpened) => onToggle(isOpened)}
                organizationName={props.process.requesterOrganization?.name}
                practitionerName={
                    props.process.requesterPractitioner
                        ? getDisplayName(props.process.requesterPractitioner)
                        : undefined
                }
                process={props.process}
                serviceType={props.process.serviceType}
                title={getServiceLabel(props.process.code, 'request', props.process.name)}
            />

            <OrthCV1RequestReadInner
                isOpen={props.itemState.isOpen}
                onToggle={(isOpened) => onToggle(isOpened)}
                orthCRequestReadData={{
                    question: props.request.question,
                    toelichting: props.request.customControlData.toelichting,
                }}
                request={props.request}
            />

            {(props.request.question || props.request.customControlData.toelichting) && (
                <ProcessItemFooter
                    isItemOpen={props.itemState.isOpen}
                    labelLess={translateKey('request.hideConsult')}
                    labelMore={translateKey('request.showConsult')}
                    onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
                />
            )}

            <RequestReadButtons
                {...props}
                editRequest={async () => await props.editRequest()}
                removeProcess={async () => {
                    await props.removeProcess();
                    if (props.request.previousRequestId && props.previousRequest?.service.code === ServiceCode.OrthO) {
                        await props.removeProcess(props.request.previousRequestId);
                    }
                }}
            />
        </ProcessContainer>
    );

    function onToggle(isOpen: boolean) {
        props.updateItemState({ ...props.itemState, isOpen });
    }
}
